import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import cx from 'classnames'

type sizeType = '5xl' | '4xl' | '3xl' | '2xl' | 'xl' | 'lg' | 'md'

const sizeTypeToClasses: Record<sizeType, string> = {
  '5xl': 'max-w-5xl',
  '4xl': 'max-w-4xl',
  '3xl': 'max-w-3xl',
  '2xl': 'max-w-2xl',
  xl: 'max-w-xl',
  lg: 'max-w-lg',
  md: 'max-w-md'
}

export default function Drawer({
  isOpen,
  close,
  children,
  sizeType = 'lg'
}: {
  isOpen: boolean
  close: () => void
  children: React.ReactNode
  sizeType?: sizeType
}) {
  return (
    <>
      <Transition show={isOpen} appear>
        <Dialog onClose={close} className="relative z-50">
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40" />
          </TransitionChild>

          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-x-full"
            enterTo="opacity-100 translate-x-0"
            leave="ease-in duration-200"
            leaveFrom="pacity-100 translate-x-0"
            leaveTo="opacity-0 translate-x-full"
          >
            <div className="bottom-10 right-10 fixed">
              <DialogPanel className={cx('overflow-auto', sizeTypeToClasses[sizeType])}>
                {children}
              </DialogPanel>
            </div>
          </TransitionChild>
        </Dialog>
      </Transition>
    </>
  )
}
